import * as React from 'react';

import { ChatMessageUserName } from '../../../../components/ChatMessageUserName';
import { useMessageContext } from '../../../../utils/messageContext';
import { useUserName, useUserColor } from '../../hooks';

export const UserNameContainer = () => {
  const { message, isFirstUserPhrase } = useMessageContext();

  const { userId: messageUserId } = message;

  const { userName, nameReplacementImageUrl } = useUserName({
    messageUserId,
    isFirstUserPhrase,
  });

  const userColor = useUserColor(message);

  if (!userName && !nameReplacementImageUrl) {
    return null;
  }

  return (
    <ChatMessageUserName userName={userName} nameReplacementImageUrl={nameReplacementImageUrl} userColor={userColor} />
  );
};
